module.exports = __webpack_public_path__ + "img/store-commercehq.29f7a0ac.svg";